/* Spark home (v2): reveal-on-scroll, hero parallax, rails, before/after. No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function hero(root) {
    root.querySelectorAll('.ssh-hero').forEach(function (h) {
      if (h.dataset.ready) return;
      h.dataset.ready = '1';
      requestAnimationFrame(function () { setTimeout(function () { h.classList.add('is-hung'); }, 60); });
      if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
      var pieces = h.querySelectorAll('.ssh-hero__piece');
      var raf = null, tx = 0, ty = 0;
      h.addEventListener('pointermove', function (e) {
        var r = h.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          pieces.forEach(function (p) {
            var d = parseFloat(p.dataset.depth || '1');
            p.style.transform = 'translate3d(' + (-tx * 18 * d).toFixed(1) + 'px,' + (-ty * 14 * d).toFixed(1) + 'px,0)';
          });
        });
      });
      h.addEventListener('pointerleave', function () {
        pieces.forEach(function (p) { p.style.transform = ''; });
      });
    });
  }

  function rails(root) {
    root.querySelectorAll('[data-rail-prev],[data-rail-next]').forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var rail = document.getElementById(b.getAttribute('aria-controls'));
        if (!rail) return;
        var dir = b.hasAttribute('data-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function beforeAfter(root) {
    root.querySelectorAll('.ssh-ba__frame').forEach(function (f) {
      var r = f.querySelector('.ssh-ba__range');
      if (!r || r.dataset.ready) return;
      r.dataset.ready = '1';
      var set = function () { f.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });
  }

  // Run the marquee only while it is on screen (it is a permanent animation otherwise).
  function marquees(root) {
    var els = root.querySelectorAll('.ssh-mq');
    if (!('IntersectionObserver' in window)) { els.forEach(function (m) { m.classList.add('is-on'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-on', e.isIntersecting); });
    });
    els.forEach(function (m) { io.observe(m); });
  }

  function init(root) { reveal(root); hero(root); rails(root); beforeAfter(root); marquees(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
